<template src="./template.html"></template>
<style lang="scss" src="@/assets/styles/_customs.scss"></style>

<script>
  import AddressModal from './AddressModal'
  import CartAddress from './CartAddress'
  import CartEmail from './CartEmail'
  import CartPayment from './CartPayment'
  import CartShipping from './CartShipping'
  import CartVoucher from './CartVoucher'
  import FooterButton from './FooterButton'
  import ProductOverview from './ProductOverview'

  import { isEqual, clone } from 'lodash'
  import { mapActions, mapState } from 'vuex'
  import { isMobile } from 'mobile-device-detect'

  export default {
    name: 'PurchasePage',
    components: {
      AddressModal,
      CartAddress,
      CartEmail,
      CartPayment,
      CartShipping,
      CartVoucher,
      FooterButton,
      ProductOverview,
    },
    props: {
      tabs: Array,
    },
    data() {
      return {
        activeTab: null,
        finishedTabs: [],
        isVisibleAddress: true,
        isVisibleEmail: true,
        isVisiblePayment: true,
        isVisibleShipping: true,
        isVisibleBonusShop: true,
        isMobile: isMobile,
        hash: '#1',
        tabList: [],
      }
    },
    computed: {
      ...mapState('cart', [
        'error',
        'min_order_value',
        'pendingPurchase',
      ]),
      ...mapState('invoiceAddress', ['newsletter']),
      ...mapState('shipping', ['shippingServices']),
      ...mapState('summary', [
        'summary',
        'coinPacksOnly',
      ]),
      ...mapState('settings', [
        'settings',
        'pendingSettings',
      ]),
      ...mapState('payment', [ 'activePaymentService' ]),
      dataLayer_products() {
        return this.summary.items ? this.summary.items.map(item => {
          return {
            id: item.product.articleNumber,
            qty: item.quantity,
            price: item.product.price,
            name: item.product.title,
          }
        }) : []
      },
      customer() {
        return process.env.customer
      },
      maxTabs() {
        return this.tabList.length
      },
      initializeBonusSldr() {
        return (
            // eslint-disable-next-line no-undef
            typeof $.reInitializeBonusSldrInCheckout === 'function'
            && this.activeTab === this.getIndex('bonus_shop_slider')
            && window.matchMedia('(max-width: 736px)').matches
        )
      },
      bonusShopActive() {
        const sldr_elem = document.querySelector('.sldr-bonus_products')
        return (
            this.getIndex('bonus_shop_slider') &&
            Boolean(sldr_elem)
        )
      },
    },
    watch: {
      dataLayer_products(val, oldVal) {
        if (val.length && !isEqual(val, oldVal) && this.customer === 'bueffelbill') {
          window.dataLayer.push({
            'event': 'basket',
            'products': this.dataLayer_products,
          })
        }
      },
      summary(summary) {
        if (summary.items.length === 0) {
          document.location.href = '/'
        }
      },
      coinPacksOnly(coinPacksOnly) {
        if (coinPacksOnly) {
          this.tabList = this.tabList.filter(tab => tab !== 'shipping')
        }
      },
      newsletter(value) {
        this.bindPaymentToWindow()
      },
      activeTab(tab) {
        if (this.isMobile && tab) {
          document.location.hash = (parseInt(tab) !== 1 ? tab : '')
          const cartHeader = document.querySelector('.logo-holder h2.mobile')
          const mapTabToHeader = {
            'email': 'selected_address',
            'address': 'selected_address',
            'payment': 'payment_method',
            'shipping': 'delivery_method',
            'bonus_shop_slider': 'bonus_shop',
            'overview': 'products',
          }
          if (cartHeader) {
            const tabString = this.tabs[tab - 1]
            cartHeader.innerText = this.$t('shopping.basket.checkout')[mapTabToHeader[tabString]]
          }
        }
      },
      hash: {
        handler(newValue, oldValue) {
          if (this.isMobile && newValue !== oldValue) {
            this.activeTab = newValue ? newValue.split('#')[1] : '1'
          }
        },
        immediate: true,
      },
      tabs: {
        handler() {
          this.tabList = clone(this.tabs)
        },
        immediate: true,
      },
      activePaymentService() {
        const appleButton = document.querySelector('apple-pay-button')
        const submitButton = document.querySelector('#submitCartButton')
        if (this.activePaymentService === 17) {
          if (appleButton.parentNode !== submitButton.parentNode) {
            submitButton.parentNode.insertBefore(appleButton, submitButton)
          }
          appleButton.style.display = 'block'
          submitButton.style.display = 'none'
        } else {
          appleButton.style.display = 'none'
          submitButton.style.display = 'block'
        }
      },
    },
    created() {
      this.activeTab = 1

      if (this.isMobile) {
        this.hashTimer()
      }

      // decide the shipping step is visible or not
      if (
        this.coinPacksOnly ||
        (
          this.customer === 'junior' && (
            this.shippingServices.length < 1 || !this.shippingServices.find(s => s.type === 'go')
          )
        )
      ) {
        this.tabList = this.tabList.filter(tab => tab !== 'shipping')
      }

      this.getAuthStatus()
    },
    mounted() {
      this.initializeSliders()
      this.bindPaymentToWindow()
      this.bindFormValidationToWindow()
    },
    methods: {
      ...mapActions('cart', ['purchase']),
      ...mapActions('auth', [ 'getAuthStatus' ]),
      onChangeVisibility(tab) {
        this[`isVisible${tab}`] = !this[`isVisible${tab}`]
      },
      initializeSliders() {
        if (!(
            [
              'hba',
              'junior',
            ].includes(this.customer))) {
          const sliders = document.querySelectorAll('.sldr')
          sliders && sliders.forEach(slider => {
            let container = null
            if (slider !== null) {
              if (slider.classList.contains('sldr-H')) {
                container = document.querySelector('#produktuebersicht')
              } else if (slider.classList.contains('sldr-bonus_products')) {
                container = document.querySelector('#bonus_shop_slider')
              }
              slider.parentNode.removeChild(slider)
              if (container) container.appendChild(slider)
            }
          })
          /* eslint-disable no-undef */
          if ($ && $.initializeSldrsInCheckout) {
            $.initializeSldrsInCheckout(sliders)
          }
          window.setTimeout(_ => {$(window).resize()}, 500)
          /* eslint-enable */
        }
      },
      async selectNextTab() {
        let result = true
        const refs = this.$refs[`obs-${this.tabList[this.activeTab - 1]}`]
        if (refs !== undefined) {
          if (this.tabList[this.activeTab - 1] === 'payment' && refs.flags.dirty) {
            result = refs.flags.valid
          } else {
            result = await refs.validate().then(result => result)
            if (!result) {
              if (document.querySelectorAll('.err')[0]) {
                document.querySelectorAll('.err')[0].parentElement.scrollIntoView()
                window.scrollBy(0, document.querySelector('#header').offsetHeight * -1)
              } else {
                window.scrollTo(0, 0)
              }
            }
          }
        }
        if (result) {
          if (this.maxTabs > this.activeTab) {
            if (!this.isTabFinished(this.activeTab)) {
              this.finishedTabs.push(this.activeTab)
            }
            this.activeTab++
            if (this.activeTab === this.getIndex('shipping') && this.shippingServices.length < 2 && !this.shippingServices.find(s => s.type === 'go')) {
              this.selectNextTab()
            }
            if (this.initializeBonusSldr) {
              // eslint-disable-next-line no-undef
              $.reInitializeBonusSldrInCheckout(document.querySelector('.sldr-bonus_products'))
            }
          }
        }
      },
      isActiveTab(tab) {
        return this.tabList[this.activeTab - 1] === tab
      },
      selectTab(tab) {
        if (this.isTabFinished(tab)) {
          this.activeTab = tab

          if (this.initializeBonusSldr) {
            // eslint-disable-next-line no-undef
            $.reInitializeBonusSldrInCheckout(document.querySelector('.sldr-bonus_products'))
          }
        }
      },
      getIndex(tab) {
        return this.tabList.indexOf(tab) + 1
      },
      hashTimer() {
        setInterval(
        () => {
          this.hash = document.location.hash
        },
        500,
        )
      },
      isTabFinished(tab) {
        return this.finishedTabs.indexOf(tab) !== -1
      },
      submitForm() {
        this.$refs.form.validate().then(result => {
          if (result && window.preparePayment && typeof window.preparePayment === 'function') {
            window.preparePayment()
          } else if (document.querySelectorAll('.err')[0]) {
            document.querySelectorAll('.err')[0].parentElement.scrollIntoView()
            window.scrollBy(0, document.querySelector('#header').offsetHeight * -1)
          } else {
            window.scrollTo(0, 0)
          }
        })
      },
      bindPaymentToWindow() {
        window.executePayment = _ => {
          this.purchase(this.newsletter)
        }
      },
      bindFormValidationToWindow() {
        window.validateForm = async _ => {
          window.validateFormSuccess = false
          await this.$refs.form.validate().then(result => {
            window.validateFormSuccess = Boolean(result)
          })
        }
      },
    },
  }
</script>
